import Styles from './NoResults.module.scss'
import { Paragraph } from 'blaze-ui/Paragraph/Paragraph'
import { NoResultsProps } from 'screens/blaze/Home/components/Catalogue/components/GroupComboBox/Types'
import { ReactComponent as Search } from './search.svg'
import { CreateNewButton } from 'screens/blaze/Home/components/Catalogue/components/GroupComboBox/CreateNewButton'

export const NoResults = ({ search }: NoResultsProps) => {
  return (
    <div className={Styles.container}>
      <div className={Styles.top}>
        <Search />
        <Paragraph variant="secondary" color="var(--dark-80)">
          We couldn't find anything for "<strong>{search}</strong>".
        </Paragraph>
      </div>
      <div>
        <CreateNewButton />
      </div>
    </div>
  )
}
